
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';

export interface AcceptValidationRequest {
    requestToken: string;
}

export interface RefuseValidationRequest {
    requestToken: string;
}

/**
 * 
 */
export class CarriedFreelancerValidationApi extends runtime.BaseAPI {

    /**
          */
    async acceptValidationRaw(requestParameters: AcceptValidationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['requestToken'] == null) {
            throw new runtime.RequiredError(
                'requestToken',
                'Required parameter "requestToken" was null or undefined when calling acceptValidation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['requestToken'] != null) {
            queryParameters['requestToken'] = requestParameters['requestToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/carried-freelancer/validation/accept`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async acceptValidation(requestParameters: AcceptValidationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acceptValidationRaw(requestParameters, initOverrides);
    }

    /**
          */
    async refuseValidationRaw(requestParameters: RefuseValidationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['requestToken'] == null) {
            throw new runtime.RequiredError(
                'requestToken',
                'Required parameter "requestToken" was null or undefined when calling refuseValidation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['requestToken'] != null) {
            queryParameters['requestToken'] = requestParameters['requestToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/carried-freelancer/validation/refuse`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async refuseValidation(requestParameters: RefuseValidationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.refuseValidationRaw(requestParameters, initOverrides);
    }

}
